import { ILinkProps, Link as BaseLink, TooltipHost } from "@fluentui/react";
import React from "react";

import { Theme } from "..";

export type LinkProps = React.PropsWithChildren<
    Pick<ILinkProps, "href" | "target" | "disabled" | "onClick" | "styles"> & {
        tooltipContent?: string;
        testAttributes?: { [key: string]: string | undefined };
    }
>;

export const Link: React.FunctionComponent<LinkProps> = ({
    href,
    target,
    tooltipContent,
    disabled,
    onClick,
    styles: propsStyles,
    children,
    testAttributes
}: LinkProps) => {
    const styles = propsStyles as Record<string, Record<string, string>>;

    const link = (
        <BaseLink
            href={href}
            target={target}
            disabled={disabled}
            onClick={onClick}
            styles={{
                root: {
                    color: disabled ? Theme.semanticColors.disabledText : Theme.semanticColors.bodyText,
                    ...styles?.root
                }
            }}
            {...testAttributes}
        >
            {children}
        </BaseLink>
    );

    if (!tooltipContent) {
        return link;
    }

    return (
        <TooltipHost content={tooltipContent} styles={{ root: { width: "100%" } }}>
            {link}
        </TooltipHost>
    );
};
